const namespaced = true

const defaultState = () => {
  return {
    excelModal: false,
  }
}

const state = defaultState()
const mutations = {
  OPEN_EXCEL_MODAL(state, payload) {
    state.excelModal = payload
  },
}

export default {
  namespaced,
  state,
  mutations,
}
